const filters = {
  formatMoney(val, maximumFractionDigits = 2) {
    // maximumFractionDigits = 2 is the default value (e.g. 200.01)
    // Passing a different value will adjust the rounding
    // e.g formatMoney(200.01, 0) will return $200
    // e.g. formatMoney(200.01, 1) will return $200.1
    var formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: maximumFractionDigits,
    });
    // Check if val is null or NaN after parsing; use 0 in such cases
    const number = parseFloat(val);
    return formatter.format(isNaN(number) ? 0 : number);
  },
  formatNumber(val) {
    return new Intl.NumberFormat().format(val);
  },
  getFirstAndLastName(val) {
    let nameParts = val.split(' ');
    let first = nameParts[0];
    nameParts.forEach((namePart, index) => {
      if (index < nameParts.length - 1 && index > 0) {
        if (index > 0) {
          first += ' ';
        }
        first += namePart;
      }
    });

    return {
      first: first,
      last: nameParts.length > 1 ? nameParts[nameParts.length - 1] : null,
    };
  },
  formatDate(val, type = 'short') {
    let options;
    switch (type) {
      case 'short':
        options = { month: 'short', day: 'numeric', year: 'numeric' };
        break;
      case 'long':
        options = { month: 'long', day: 'numeric', year: 'numeric' };
        break;
      case 'time':
        options = { hour: 'numeric', minute: 'numeric', hour12: true };

      default:
        options = {
          month: 'long', // display the full month name (e.g. "April")
          day: 'numeric', // display the day of the month as a number (e.g. "25")
          year: 'numeric', // display the year as a number (e.g. "2023")
          hour: 'numeric', // display the hour as a number (e.g. "11")
          minute: '2-digit', // display the minute as a 2-digit number (e.g. "30")
          hour12: true, // use 12-hour time format (e.g. "11:30AM")
        };
        break;
    }
    const date = new Date(val);

    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  },
  orderStatusTranslate(val) {
    const status = {
      succeeded: {
        text: 'Success',
        type: 'success',
      },
      failed: {
        text: 'Failed',
        type: 'error',
      },
      refunded: {
        text: 'Refunded',
        type: 'canceled',
      },
      partially_refunded: {
        text: 'Partial Refund',
        type: 'success',
      },
      disputed: {
        text: 'Disputed',
        type: 'pending',
      },
      canceled: {
        text: 'Canceled',
        type: 'canceled',
      },
    };
    return status[val];
  },
  // Used to filter objects by: Past 7 Days
  // Past Month, Past Year, and All
  filterByDate(objects, dateFilter) {
    if (!Array.isArray(objects)) {
      console.error('filterByDate: objects is not an array', objects);
      return [];
    }
    let now = new Date();
    objects.sort((a, b) => new Date(b.enteredDate) - new Date(a.enteredDate));

    const dateThresholds = {
      past7Days: new Date().setDate(now.getDate() - 7),
      pastMonth: new Date().setMonth(now.getMonth() - 1),
      pastYear: new Date().setFullYear(now.getFullYear() - 1),
    };

    if (dateThresholds[dateFilter]) {
      objects = objects.filter((object) => new Date(object.enteredDate) >= dateThresholds[dateFilter]);
    }

    return objects;
  },
  // Used to sort objects by two different options
  // e.g.: Most Recent/Least Recent, Low to High/High to Low
  sortByDate(objects, sortType, optionA, optionB, propertyName) {
    if (sortType === optionA) {
      objects.sort((a, b) => new Date(b[propertyName]) - new Date(a[propertyName]));
    }

    if (sortType === optionB) {
      objects.sort((a, b) => new Date(a[propertyName]) - new Date(b[propertyName]));
    }

    return objects;
  },
  // Used to sort objects by two different amount options
  // e.g.: Most Raised/Least Raised
  sortByAmount(objects, sortType, optionA, optionB, propertyName) {
    if (sortType === optionA) {
      objects.sort((a, b) => b[propertyName] - a[propertyName]);
    }

    if (sortType === optionB) {
      objects.sort((a, b) => a[propertyName] - b[propertyName]);
    }

    return objects;
  },
  // Used to sort objects by two different name options
  // e.g.: A - Z, Z - A
  sortByName(objects, sortType, optionA, optionB, propertyName) {
    const getNestedProperty = (obj, path) => {
      return path.split('.').reduce((acc, part) => acc && acc[part], obj);
    };

    if (sortType === optionA) {
      objects.sort((a, b) => {
        const nameA = getNestedProperty(a, propertyName) || '';
        const nameB = getNestedProperty(b, propertyName) || '';
        return nameA.localeCompare(nameB);
      });
    }

    if (sortType === optionB) {
      objects.sort((a, b) => {
        const nameA = getNestedProperty(a, propertyName) || '';
        const nameB = getNestedProperty(b, propertyName) || '';
        return nameB.localeCompare(nameA);
      });
    }

    return objects;
  },
};
export default filters;
